import { useState } from "react";
import { UserPlus } from "lucide-react";
import { Link, useNavigate } from "react-router-dom";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const [password, setPassword] = useState("");
  const navigate = useNavigate();

const handleRegister = async (e) => {
  e.preventDefault();

  if (!name.trim() || !email.trim() || !password.trim() || !phone.trim()) {
    alert("Please fill out all fields.");
    return;
  }

  if (password.length < 6) {
    alert("Password must be at least 6 characters long.");
    return;
  }

  try {
    const response = await fetch("https://zaichat.net/api/register", {
      method: "POST",
      body: JSON.stringify({
        user_name: name,
        email: email,
        password: password,
        phone_number: phone,
      }),
      headers: { "Content-Type": "application/json" },
    });

    if (!response.ok) {
      alert("Registration failed. Please try again.");
      return;
    }

    navigate("/verify");
  } catch (error) {
    console.error("Registration error:", error);
    alert("Something went wrong. Please try again later.");
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-cream to-white px-4">
      <div className="bg-white rounded-3xl shadow-2xl p-10 w-full max-w-md text-center border border-primary/10">
        {/* Logo + Header */}
        <div className="mb-8">
          <img
            src="/zuccesslogo2.png"
            alt="Zuccess Logo"
            className="w-24 mx-auto drop-shadow-md"
          />
          <h1 className="text-3xl font-extrabold text-primary mt-4 tracking-tight">
            Create Account
          </h1>
          <p className="text-dark/70 text-sm mt-1">
            Join the future of{" "}
            <span className="text-accent font-semibold">AI-powered business</span>
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleRegister} className="space-y-5 text-left">
          <div>
            <label className="block text-sm font-medium text-primary mb-1">
              Full Name
            </label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full border border-primary/20 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              placeholder="John Doe"
              required
            />
          </div>
                <div>
            <label className="block text-sm font-medium text-primary mb-1">
              Phone Number
            </label>
            <input
              type="text"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-full border border-primary/20 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              placeholder="John Doe"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-primary mb-1">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full border border-primary/20 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              placeholder="you@example.com"
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-primary mb-1">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full border border-primary/20 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
              placeholder="••••••••"
              required
            />
          </div>

          {/* Register Button */}
          <button
            type="submit"
            className="w-full bg-accent text-white py-3 rounded-lg font-semibold hover:bg-accent/90 transition flex items-center justify-center gap-2 shadow-md"
          >
            <UserPlus size={18} /> Register
          </button>
        </form>

        {/* Footer Links */}
        <p className="text-sm text-dark/70 mt-6">
          Already have an account?{" "}
          <Link
            to="/login"
            className="text-accent font-semibold hover:underline hover:text-primary"
          >
            Log In
          </Link>
        </p>

        {/* Footer Note */}
        <p className="text-[11px] text-dark/50 mt-8">
          © {new Date().getFullYear()} Zuccess. All rights reserved.
        </p>
      </div>
    </div>
  );
}
